import Vue from 'vue'
import Vuex from 'vuex'
import { systemStore } from 'core/store/index'
import createPersistedState from 'vuex-persistedstate'
import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theFinalReturnList: [],
    theFinalList: [],
    search: []
  },
  getters: {
    getField
  },
  mutations: {
    setSearch (state, config) {
      state.search = config
    },
    updateField
  },
  actions: {
  },
  modules: {
    systemStore
  },
  plugins: [createPersistedState({ storage: window.sessionStorage })]
})
